import React from 'react';
import { Cushion, Grid, ShimmerAvatar, ShimmerTypography, Space } from '@pitchero/react-ui';

const CommentsLoadingPlaceholder = () => (
  <Cushion vertical="small">
    <Space bottom="small">
      <Grid columns="48px 1fr" columnGap="small" rows="repeat(auto-fit, 18px)">
        <div style={{ gridRow: 'span 2' }}>
          <ShimmerAvatar size={48} />
        </div>
        <ShimmerTypography width="60%" />
        <ShimmerTypography width="40%" />
      </Grid>
    </Space>

    <ShimmerTypography />
  </Cushion>
);

export default CommentsLoadingPlaceholder;
